<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <div class="header-left">
      <button mat-icon-button (click)="back()" matTooltip="Back to directors">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="header-titles">
        <h2>{{ director?.fullName || 'Director' }}</h2>
      </div>
    </div>
  </div>

  <mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTabIndex">
    <mat-tab label="Information">
      <div class="container">
        <div class="left-container">
          <section class="section-container nrg-border-radius">
            <div class="section-header">Basic Information</div>
            <div class="section-content">
              <div class="form-field-container form-field-container-with-columns">
                <div class="form-field-container-half">
                  <div class="form-field-container">
                    <mat-form-field appearance="fill" class="form-field">
                      <mat-label>Full Name</mat-label>
                      <input matInput readonly [value]="director?.fullName || ''">
                    </mat-form-field>
                  </div>
                  <div class="form-field-container">
                    <mat-form-field appearance="fill" class="form-field">
                      <mat-label>Title</mat-label>
                      <input matInput readonly [value]="director?.honorificTitleName || ''">
                    </mat-form-field>
                  </div>
                </div>
                <div class="form-field-container-half">
                  <div class="photo-upload-container">
                    <div class="photo-upload-content">
                      <div class="photo-preview-container">
                        @if (photoUrl) {
                          <div class="photo-preview">
                            <img [src]="photoUrl" alt="Profile Photo" class="profile-image">
                          </div>
                        } @else {
                          <div class="photo-placeholder">
                            <mat-icon>person</mat-icon>
                            <span>No photo</span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-field-container form-field-container-with-columns">
                <div class="form-field-container-quarter">
                  <mat-form-field appearance="fill" class="form-field">
                    <mat-label>Year of Birth</mat-label>
                    <input matInput readonly [value]="director?.yearOfBirth || ''">
                  </mat-form-field>
                </div>
                <div class="form-field-container-quarter">
                  <mat-form-field appearance="fill" class="form-field">
                    <mat-label>Age</mat-label>
                    <input matInput readonly [value]="director?.age || ''">
                  </mat-form-field>
                </div>
                <div class="form-field-container-half form-field-align-end">
                  <span class="readonly-flag" [class.checked]="director?.yearOfBirthConfirmed">
                    <mat-icon>{{ director?.yearOfBirthConfirmed ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                    Year of Birth Confirmed
                  </span>
                </div>
              </div>

              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Gender</mat-label>
                  <input matInput readonly [value]="genderLabels[director?.gender ?? 0]">
                </mat-form-field>
              </div>

              <div class="form-field-container form-field-container-with-columns">
                <div class="form-field-container-half">
                  <mat-form-field appearance="fill" class="form-field">
                    <mat-label>Nationality</mat-label>
                    <input matInput readonly [value]="director?.nationalityName || ''">
                  </mat-form-field>
                </div>
                <div class="form-field-container-half">
                  <mat-form-field appearance="fill" class="form-field">
                    <mat-label>Secondary Nationality</mat-label>
                    <input matInput readonly [value]="director?.secondNationalityName || ''">
                  </mat-form-field>
                </div>
              </div>

              <div class="form-field-container form-field-container-with-columns">
                <div class="form-field-container-column">
                  <span class="readonly-flag" [class.checked]="director?.isDeceased">
                    <mat-icon>{{ director?.isDeceased ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                    Passed Away
                  </span>
                </div>
                @if (director?.isDeceased) {
                  <div class="form-field-container-column flex-grow">
                    <mat-form-field appearance="fill" class="full-width-field">
                      <mat-label>Passed Away Date</mat-label>
                      <input matInput readonly [value]="formatDate(director?.dateOfDeath)">
                    </mat-form-field>
                  </div>
                }
              </div>
            </div>
          </section>
        </div>

        <div class="right-container">
          <section class="section-container nrg-border-radius">
            <div class="section-header">Other Information</div>
            <div class="section-content">
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Profession</mat-label>
                  <input matInput readonly [value]="director?.professionName || ''">
                </mat-form-field>
              </div>
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Industry Expertise 1</mat-label>
                  <input matInput readonly [value]="director?.industryExpertise1Name || ''">
                </mat-form-field>
              </div>
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Industry Expertise 2</mat-label>
                  <input matInput readonly [value]="director?.industryExpertise2Name || ''">
                </mat-form-field>
              </div>
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Professional Qualification</mat-label>
                  <input matInput readonly [value]="director?.qualificationName || ''">
                </mat-form-field>
              </div>
              <div class="form-field-container">
                <span class="readonly-flag" [class.checked]="director?.hasFinancialExpertise">
                  <mat-icon>{{ director?.hasFinancialExpertise ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                  Has Financial Expertise
                </span>
              </div>
              @if (director?.hasFinancialExpertise) {
                <div class="form-field-container">
                  <mat-form-field appearance="fill" class="form-field">
                    <mat-label>Financial Expertise</mat-label>
                    <input matInput readonly [value]="director?.financialExpertiseName || ''">
                  </mat-form-field>
                </div>
              }
              <div class="form-field-container">
                <span class="readonly-flag" [class.checked]="director?.hasPoliticalPosition">
                  <mat-icon>{{ director?.hasPoliticalPosition ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                  Has Political Position
                </span>
              </div>
              @if (director?.hasPoliticalPosition) {
                <div class="form-field-container">
                  <mat-form-field appearance="fill" class="form-field">
                    <mat-label>Political Position</mat-label>
                    <input matInput readonly [value]="director?.politicalPositionName || ''">
                  </mat-form-field>
                </div>
              }
            </div>
          </section>
        </div>
      </div>

      <section class="section-container nrg-border-radius">
        <div class="section-header">Curriculum Vitae</div>
        <div class="section-content">
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Curriculum Vitae Summary</mat-label>
              <textarea matInput readonly rows="6" [value]="director?.cvSummary || ''"></textarea>
            </mat-form-field>
          </div>
        </div>
      </section>

      <section class="section-container nrg-border-radius">
        <div class="section-header">Work Experience</div>
        <div class="section-content">
          @if (sortedWorkExperience.length === 0) {
            <div class="empty-state">No work experience available</div>
          } @else {
            <table mat-table [dataSource]="sortedWorkExperience" class="mat-elevation-z2 view-table">
              <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef>Company</th>
                <td mat-cell *matCellDef="let we">{{ workExperienceCompanyName(we) }}</td>
              </ng-container>
              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef>Position</th>
                <td mat-cell *matCellDef="let we">{{ we.jobPositionName }}</td>
              </ng-container>
              <ng-container matColumnDef="startDate">
                <th mat-header-cell *matHeaderCellDef>Start Date</th>
                <td mat-cell *matCellDef="let we">{{ formatDate(we.from) }}</td>
              </ng-container>
              <ng-container matColumnDef="endDate">
                <th mat-header-cell *matHeaderCellDef>End Date</th>
                <td mat-cell *matCellDef="let we">{{ we.isPresent ? 'Present' : (formatDate(we.until) || '—') }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="workExperienceDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: workExperienceDisplayedColumns;"></tr>
            </table>
          }
        </div>
      </section>

      <section class="section-container nrg-border-radius">
        <div class="section-header">Training & Education</div>
        <div class="section-content">
          @if ((director?.trainingOrEducation?.length || 0) === 0) {
            <div class="empty-state">No training or education available</div>
          } @else {
            <table mat-table [dataSource]="director?.trainingOrEducation || []" class="mat-elevation-z2 view-table">
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let te">{{ trainingTypeLabels[te.type] || '' }}</td>
              </ng-container>
              <ng-container matColumnDef="educationField">
                <th mat-header-cell *matHeaderCellDef>Education Field</th>
                <td mat-cell *matCellDef="let te">{{ te.educationFieldName }}</td>
              </ng-container>
              <ng-container matColumnDef="university">
                <th mat-header-cell *matHeaderCellDef>University</th>
                <td mat-cell *matCellDef="let te">{{ te.universityName }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="trainingDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: trainingDisplayedColumns;"></tr>
            </table>
          }
        </div>
      </section>
    </mat-tab>

    <mat-tab label="Positions">
      <div class="positions-container">
        <div class="positions-view-toggle">
          <mat-button-toggle-group [(value)]="positionsViewMode" hideSingleSelectionIndicator>
            <mat-button-toggle value="year">By Year</mat-button-toggle>
            <mat-button-toggle value="company">By Company</mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        @if (positionsViewMode === 'year') {
          <div class="positions-section">
            <h3 class="positions-section-title">Board Positions</h3>
            @if (boardPositionsByYear.length === 0) {
              <div class="empty-state">No board positions available</div>
            }
            @for (group of boardPositionsByYear; track group.year) {
              <section class="section-container nrg-border-radius">
                <div class="section-header">Year: {{ group.year }}</div>
                <div class="section-content">
                  <div class="positions-list">
                    <table mat-table [dataSource]="group.positions" class="mat-elevation-z2 board-table">
                      <ng-container matColumnDef="companyName">
                        <th mat-header-cell *matHeaderCellDef>Company</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.companyName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="classification">
                        <th mat-header-cell *matHeaderCellDef>Classification</th>
                        <td mat-cell *matCellDef="let pos">{{ getClassificationLabel(pos.classification) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="occupationName">
                        <th mat-header-cell *matHeaderCellDef>Occupation</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.occupationName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="tenure">
                        <th mat-header-cell *matHeaderCellDef>Tenure</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.tenure }}</td>
                      </ng-container>
                      <ng-container matColumnDef="meetingAttendancePercentage">
                        <th mat-header-cell *matHeaderCellDef>M.A. %</th>
                        <td mat-cell *matCellDef="let pos">{{ formatPercentage(pos.meetingAttendancePercentage) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="forVotesPct">
                        <th mat-header-cell *matHeaderCellDef>For%</th>
                        <td mat-cell *matCellDef="let pos">{{ formatPercentage(pos.forVotesPct) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="againstVotesPct">
                        <th mat-header-cell *matHeaderCellDef>Against%</th>
                        <td mat-cell *matCellDef="let pos">{{ formatPercentage(pos.againstVotesPct) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="auditCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>Audit</th>
                        <td mat-cell *matCellDef="let pos">{{ getAuditRoleLabel(pos.auditCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="remunerationCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>Remuneration</th>
                        <td mat-cell *matCellDef="let pos">{{ getCommitteeRoleLabel(pos.remunerationCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="nominationCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>Nomination</th>
                        <td mat-cell *matCellDef="let pos">{{ getCommitteeRoleLabel(pos.nominationCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="cgCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>C.G.</th>
                        <td mat-cell *matCellDef="let pos">{{ getCommitteeRoleLabel(pos.cgCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="shares">
                        <th mat-header-cell *matHeaderCellDef>Shares</th>
                        <td mat-cell *matCellDef="let pos">{{ formatNumber(pos.firstClassShares) }}</td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="boardDisplayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: boardDisplayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </section>
            }
          </div>

          <div class="positions-section">
            <h3 class="positions-section-title">Executive Management</h3>
            @if (executivePositionsByYear.length === 0) {
              <div class="empty-state">No executive positions available</div>
            }
            @for (group of executivePositionsByYear; track group.year) {
              <section class="section-container nrg-border-radius">
                <div class="section-header">Year: {{ group.year }}</div>
                <div class="section-content">
                  <div class="positions-list">
                    <table mat-table [dataSource]="group.positions" class="mat-elevation-z2 executive-table">
                      <ng-container matColumnDef="companyName">
                        <th mat-header-cell *matHeaderCellDef>Company</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.companyName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="occupationName">
                        <th mat-header-cell *matHeaderCellDef>Occupation</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.occupationName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="tenure">
                        <th mat-header-cell *matHeaderCellDef>Tenure</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.tenure }}</td>
                      </ng-container>
                      <ng-container matColumnDef="shares">
                        <th mat-header-cell *matHeaderCellDef>Shares</th>
                        <td mat-cell *matCellDef="let pos">{{ formatNumber(pos.firstClassShares) }}</td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="executiveDisplayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: executiveDisplayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </section>
            }
          </div>
        } @else {
          <div class="positions-section">
            <h3 class="positions-section-title">Board Positions</h3>
            @if (boardPositionsByCompany.length === 0) {
              <div class="empty-state">No board positions available</div>
            }
            @for (group of boardPositionsByCompany; track group.companyId) {
              <section class="section-container nrg-border-radius">
                <div class="section-header">{{ group.companyName }}</div>
                <div class="section-content">
                  <div class="positions-list">
                    <table mat-table [dataSource]="group.positions" class="mat-elevation-z2 board-table">
                      <ng-container matColumnDef="year">
                        <th mat-header-cell *matHeaderCellDef>Year</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.year }}</td>
                      </ng-container>
                      <ng-container matColumnDef="classification">
                        <th mat-header-cell *matHeaderCellDef>Classification</th>
                        <td mat-cell *matCellDef="let pos">{{ getClassificationLabel(pos.classification) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="occupationName">
                        <th mat-header-cell *matHeaderCellDef>Occupation</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.occupationName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="tenure">
                        <th mat-header-cell *matHeaderCellDef>Tenure</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.tenure }}</td>
                      </ng-container>
                      <ng-container matColumnDef="meetingAttendancePercentage">
                        <th mat-header-cell *matHeaderCellDef>M.A. %</th>
                        <td mat-cell *matCellDef="let pos">{{ formatPercentage(pos.meetingAttendancePercentage) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="forVotesPct">
                        <th mat-header-cell *matHeaderCellDef>For%</th>
                        <td mat-cell *matCellDef="let pos">{{ formatPercentage(pos.forVotesPct) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="againstVotesPct">
                        <th mat-header-cell *matHeaderCellDef>Against%</th>
                        <td mat-cell *matCellDef="let pos">{{ formatPercentage(pos.againstVotesPct) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="auditCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>Audit</th>
                        <td mat-cell *matCellDef="let pos">{{ getAuditRoleLabel(pos.auditCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="remunerationCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>Remuneration</th>
                        <td mat-cell *matCellDef="let pos">{{ getCommitteeRoleLabel(pos.remunerationCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="nominationCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>Nomination</th>
                        <td mat-cell *matCellDef="let pos">{{ getCommitteeRoleLabel(pos.nominationCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="cgCommitteeRole">
                        <th mat-header-cell *matHeaderCellDef>C.G.</th>
                        <td mat-cell *matCellDef="let pos">{{ getCommitteeRoleLabel(pos.cgCommitteeRole) }}</td>
                      </ng-container>
                      <ng-container matColumnDef="shares">
                        <th mat-header-cell *matHeaderCellDef>Shares</th>
                        <td mat-cell *matCellDef="let pos">{{ formatNumber(pos.firstClassShares) }}</td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="boardByCompanyDisplayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: boardByCompanyDisplayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </section>
            }
          </div>

          <div class="positions-section">
            <h3 class="positions-section-title">Executive Management</h3>
            @if (executivePositionsByCompany.length === 0) {
              <div class="empty-state">No executive positions available</div>
            }
            @for (group of executivePositionsByCompany; track group.companyId) {
              <section class="section-container nrg-border-radius">
                <div class="section-header">{{ group.companyName }}</div>
                <div class="section-content">
                  <div class="positions-list">
                    <table mat-table [dataSource]="group.positions" class="mat-elevation-z2 executive-table">
                      <ng-container matColumnDef="year">
                        <th mat-header-cell *matHeaderCellDef>Year</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.year }}</td>
                      </ng-container>
                      <ng-container matColumnDef="occupationName">
                        <th mat-header-cell *matHeaderCellDef>Occupation</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.occupationName }}</td>
                      </ng-container>
                      <ng-container matColumnDef="tenure">
                        <th mat-header-cell *matHeaderCellDef>Tenure</th>
                        <td mat-cell *matCellDef="let pos">{{ pos.tenure }}</td>
                      </ng-container>
                      <ng-container matColumnDef="shares">
                        <th mat-header-cell *matHeaderCellDef>Shares</th>
                        <td mat-cell *matCellDef="let pos">{{ formatNumber(pos.firstClassShares) }}</td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="executiveByCompanyDisplayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: executiveByCompanyDisplayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </section>
            }
          </div>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
